<template>
  <button class="slideButton my-2" :style="{width: width}">
      <v-icon name="icon"><slot name="icon"></slot></v-icon>
      <span name="text"><slot name="text"></slot></span>
      <div id="btn-bubble" style="position:absolute;left:0px;"></div>
  </button>
</template>

<script>
export default {
  props: ['width'],
}
</script>

<style scoped>

</style>
